module.exports = __webpack_public_path__ + "img/40_01_011_978.2f4d3de2.jpg";